module.exports = __webpack_public_path__ + "img/product_1_logoVocale.b976e113.png";